import axios from 'axios';
<template>
  <vx-card>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-2/4 md:w-2/4 lg:w-2/4 mb-2">
        <vs-input
          label="عنوان المقالة"
          class="w-full"
          v-model="paragraph.title"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-2/4 md:w-2/4 lg:w-2/4 mb-2">
        <quill-editor v-model="paragraph.body"></quill-editor>

            <!-- <vs-textarea label="المقالة" v-model="paragraph.body" /> -->
      </div>
    </div>
    
    <div class="vx-row">
        
        <div class="vx-col w-1/3 sm:w-1/4 md:w-1/4 lg:w-1/4  mb-2">
            <label>المستوى</label>
            <v-select
            class="w-full "
            :options="levelsOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="paragraph.level_id"
            />
        </div>

        <div class="vx-col w-1/3 sm:w-1/4 md:w-1/4 lg:w-1/4  mb-2">
            <label>الموضوع</label>
            <v-select
            class="w-full "
            :options="topicsOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
             v-model="paragraph.topic_id"
            />
        </div>
        <div class="vx-col w-1/3 sm:w-2/4 md:w-2/4 lg:w-2/4 mb-2">
            <vs-input type="number" label="عدد الكلمات" placeholder="عدد الكلمات" v-model="paragraph.number_of_words" />
         </div>
    </div>

    <div class="vx-row" >
      <div class="vx-col w-full">
        <vs-button class=" w-full" @click="submit" :disabled="!validInput">حفظ</vs-button>
      </div>
    </div>

  </vx-card>
</template>

<script>
import vSelect from "vue-select";
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
    components:{
        vSelect,
        quillEditor
    },
    data(){
        return {
            levelsOptions: [],
            topicsOptions: [],

            paragraph: {
                title: '',
                body: '',
                topic_id: null,
                level_id: null,
                number_of_words: ''                
            }
        }
    },
    methods: {
        async submit(){

            this.$vs.loading();
            this.paragraph.topic_id = this.paragraph.topic_id.id;
            this.paragraph.level_id = this.paragraph.level_id.id
            await axios.post('paragraphs', this.paragraph).then(res => {
                this.$vs.notify({
                    title: "تمت العملية بنجاح",
                    text: "تم إضافة المقالة بنجاح",
                    color: "success",
                    position: "top-left"
                });
                this.$router.push("/paragraph/"+ res.data.data.id +"/addQuestion");
            })
            this.$vs.loading.close();
        },
        async getQuestionFeatures(){
            this.$vs.loading();

            await axios.get('question-feature').then( res => {
                res.data.data.levels.forEach(element => {
                    element.label = element.name;
                });
                this.levelsOptions = res.data.data.levels

                res.data.data.topics.forEach(element => {
                    element.label = element.name;
                });
                this.topicsOptions = res.data.data.topics
            })
            this.$vs.loading.close();
        }
    },
    mounted(){
        this.getQuestionFeatures();
    },
    computed:{
        validInput(){
            return this.paragraph.title.length && this.paragraph.body.length && this.paragraph.number_of_words.length && this.paragraph.topic_id != null && this.paragraph.level_id != null ;
        }
    }
    
}
</script>